'use client'

import type { LoyaltyRegisterModalProps } from '@maestro/commerce-blocks/loyalty/components/loyalty-register-form/loyalty-register.types'

import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import { useLoyaltyRegisterModal } from '@maestro/commerce-blocks/loyalty/components/loyalty-register-form/batons/use-register-modal'
import { SlideInBody } from '@pearlconvert/ui/components/slide-in'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

const LoyaltyRegisterForm = dynamic(
  () =>
    import('@maestro/commerce-blocks/loyalty/components/loyalty-register-form/loyalty-register-form')
)

export default function LoyaltyRegisterModal(props: LoyaltyRegisterModalProps) {
  const { cmsPlaceholders, consents, stores } = props
  const t = useTranslations('commerce-blocks')
  const { addModal } = useModals()
  const { loyaltyRegisterModalKey } = useLoyaltyRegisterModal()

  useEffect(() => {
    addModal({
      key: loyaltyRegisterModalKey,
      hash: loyaltyRegisterModalKey,
      Component: (
        <SlideInBody>
          <LoyaltyRegisterForm
            cmsPlaceholders={cmsPlaceholders}
            consents={consents}
            stores={stores}
          />
        </SlideInBody>
      ),
      props: {
        title: t('auth.register.title-loyalty'),
        customClassName: 'register-modal',
      },
    })
  }, [addModal, cmsPlaceholders, consents, loyaltyRegisterModalKey, stores, t])

  return null
}
